var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { atom } from "jotai";
import { useAtomValue } from "jotai";
import { useCallback, useState } from "react";
import { metrics } from "../analytics/events";
export var FullScreenContentAtom = atom(null);
export var useFullScreen = function () {
    var fullScreenContent = useAtomValue(FullScreenContentAtom);
    var _a = __read(useState(false), 2), enabled = _a[0], setEnabled = _a[1];
    var toggleFullscreen = useCallback(function () {
        if (!document.fullscreenEnabled || fullScreenContent == null)
            return;
        if (!document.fullscreenElement) {
            metrics.clickOnActivateFullscreen();
            fullScreenContent.requestFullscreen();
            setEnabled(true);
        }
        else if (document.exitFullscreen) {
            metrics.clickOnDectivateFullscreen();
            document.exitFullscreen();
            setEnabled(false);
        }
    }, [fullScreenContent]);
    return { toggleFullscreen: toggleFullscreen, enabled: enabled };
};
